import axios from 'axios';

import { showCustomToast } from '../controls/CustomToast';

import { history } from '../utils/History';
import { clearStorage } from '../utils/util';
import { changeApi, changeReqData, changeResDataKey } from '../utils/http';

const requestToastId = 'request-toast-id';
const timeout = process.env.NODE_ENV !== 'production' ? 65000 : 180000;

const serviceTokenNew = axios.create({
  headers: {
    get: {
      'Content-Type':
        'application/json;application/x-www-form-urlencoded;charset=utf-8'
    },
    post: {
      'Content-Type': 'application/json;charset=utf-8'
    },
    put: {
      'Content-Type': 'application/json;charset=utf-8'
    }
  },
  withCredentials: false,
  timeout: timeout
});

let pending = [];
let CancelToken = axios.CancelToken;
let removePending = (config) => {
  for (let p in pending) {
    if (pending[p].u === config.url + '&' + config.method) {
      pending[p].f();
      pending.splice(p, 1);
    }
  }
};

serviceTokenNew.interceptors.request.use(
  (config) => {
    if (config.url !== '/api/products/import/importtostore') {
      removePending(config);
    }

    config.url = changeApi(config);
    config.data = changeReqData(config);

    config.cancelToken = new CancelToken((c) => {
      pending.push({ u: config.url + '&' + config.method, f: c });
    });

    if (config.isTicketApi) {
      let auth = process.env.REACT_APP_TICKET_AUTH;
      config.headers['Authorization'] =
        'Basic ' + Buffer.from(auth).toString('base64');
    } else {
      let token = localStorage.getItem('token');
      config.headers['Authorization'] = 'jwt ' + token;
    }

    return config;
  },
  (error) => {
    error.data = {};
    error.data.msg = 'Error!';
    return Promise.resolve(error);
  }
);

const defaultResponseInterceptors = (response) => {
  changeResDataKey(response);
  const res = response.data;
  if (res.success === true) {
    return res;
  } else {
    return Promise.reject(res.message);
  }
};

const defaultResponseError = (error) => {
  // console.log('defaultResponseError', error);
  if (error.code === 'ECONNABORTED') {
    showCustomToast(
      'Sorry, we could not complete your request. Please try again later or contact info@dropshipzone.com.au if the problem persists.'
    );
  }
  if (error.response) {
    const { status } = error.response;
    if (status === 401) {
      const return_url = sessionStorage.getItem('returnUrl');
      let url = `/login?sessionExpired=true`;
      if (return_url) {
        url += `&return_url=${return_url}`;
      }
      clearStorage();
      sessionStorage.clear();
      localStorage.setItem('forceRefresh', 'true');
      history.push(url);
      showCustomToast('Your session has expired, please login again', {
        toastId: requestToastId
      });
    } else if (status === 404) {
      // console.log('defaultResponseError', error.config.isTicketApi);
      if (!error.config.isTicketApi) {
        history.push('/notfound');
      }
    } else {
      showCustomToast(
        'Sorry, we could not complete your request. Please try again later or contact info@dropshipzone.com.au if the problem persists.'
      );
    }
  }
  return Promise.reject(error);
};

serviceTokenNew.interceptors.response.use(
  defaultResponseInterceptors,
  defaultResponseError
);

export default serviceTokenNew;
